import { memo } from 'react';
import { Button as MuiButton, CircularProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { ButtonProps } from '@mui/material';

const useStyles = makeStyles({ name: 'LoadingButton' })((theme) => ({
  root: {
    pointerEvents: 'none',
    userSelect: 'none',
  },
  containedPrimary: {
    backgroundColor: theme.palette.primary.light,
  },
  containedSecondary: {
    backgroundColor: theme.palette.secondary.light,
  },
  containedSuccess: {
    backgroundColor: theme.palette.success.light,
  },
  containedError: {
    backgroundColor: theme.palette.error.light,
  },
  containedInfo: {
    backgroundColor: theme.palette.info.light,
  },
  containedWarning: {
    backgroundColor: theme.palette.warning.light,
  },
}));

export const LoadingButton = memo<ButtonProps>(({ color = 'primary', ...restProps }) => {
  const { classes } = useStyles();

  return (
    <MuiButton
      classes={classes}
      color={color}
      {...restProps}
    >
      <CircularProgress
        color={color}
        size={16}
        aria-label={restProps['aria-label'] || ''}
      />
    </MuiButton>
  );
});
